import { useLang } from '@/pages/home/context/LanguageContext';

const servicesPT = [
  {
    icon: 'ri-temp-cold-line',
    title: 'Manutenção de Sistemas AVAC',
    description: 'Manutenção preventiva e corretiva de sistemas de Aquecimento, Ventilação e Ar Condicionado para ambientes industriais e comerciais de grande escala.',
    image: 'https://public.readdy.ai/ai/img_res/edited_93a8d2abce86e309e59fb30ada5928a5_75933cd6.jpg',
    tag: 'AVAC',
  },
  {
    icon: 'ri-settings-3-line',
    title: 'Instalação de Climatização Industrial',
    description: 'Projeto e instalação de sistemas de climatização de alta performance para instalações industriais, garantindo eficiência energética e conforto operacional.',
    image: 'https://public.readdy.ai/ai/img_res/edited_f23c134d6ba50bc752bc6f9553ac29da_75933cd6.jpg',
    tag: 'Instalação',
  },
  {
    icon: 'ri-oil-line',
    title: 'Serviços para Setor Petrolífero',
    description: 'Assistência técnica especializada para instalações petrolíferas, com foco em segurança operacional, conformidade normativa e continuidade das operações.',
    image: 'https://public.readdy.ai/ai/img_res/edited_6ec62a84d77517c9b7daa78af6ac0624_75933cd6.jpg',
    tag: 'Petróleo & Gás',
    dark: true,
  },
  {
    icon: 'ri-search-eye-line',
    title: 'Inspeção Técnica de Equipamentos',
    description: 'Diagnóstico e inspeção técnica detalhada de equipamentos industriais, identificando falhas potenciais antes que se tornem problemas críticos.',
    image: 'https://public.readdy.ai/ai/img_res/edited_ac86fdbcc2ff33a1d05e128ae9162b3e_75933cd6.jpg',
    tag: 'Inspeção',
  },
  {
    icon: 'ri-blaze-line',
    title: 'Manutenção de Sistemas de Ventilação',
    description: 'Manutenção e otimização de sistemas de ventilação industrial, assegurando qualidade do ar, segurança dos trabalhadores e eficiência dos processos.',
    image: 'https://public.readdy.ai/ai/img_res/edited_8d762980a70930b9a72097e4a32a0d10_75933cd6.jpg',
    tag: 'Ventilação',
  },
  {
    icon: 'ri-tools-line',
    title: 'Manutenção Preventiva e Corretiva',
    description: 'Programas estruturados de manutenção preventiva e corretiva para maximizar a vida útil dos equipamentos e minimizar paragens não planeadas.',
    image: 'https://public.readdy.ai/ai/img_res/edited_796c426e1b97e15b704a043b3e81a459_75933cd6.jpg',
    tag: 'Manutenção',
  },
];

const servicesEN = [
  {
    icon: 'ri-temp-cold-line',
    title: 'HVAC System Maintenance',
    description: 'Preventive and corrective maintenance of Heating, Ventilation and Air Conditioning systems for large-scale industrial and commercial environments.',
    image: 'https://public.readdy.ai/ai/img_res/edited_93a8d2abce86e309e59fb30ada5928a5_75933cd6.jpg',
    tag: 'HVAC',
  },
  {
    icon: 'ri-settings-3-line',
    title: 'Industrial Air Conditioning Installation',
    description: 'Design and installation of high-performance air conditioning systems for industrial facilities, ensuring energy efficiency and operational comfort.',
    image: 'https://public.readdy.ai/ai/img_res/edited_f23c134d6ba50bc752bc6f9553ac29da_75933cd6.jpg',
    tag: 'Installation',
  },
  {
    icon: 'ri-oil-line',
    title: 'Oil Sector Services',
    description: 'Specialized technical assistance for oil facilities, focusing on operational safety, regulatory compliance and continuity of operations.',
    image: 'https://public.readdy.ai/ai/img_res/edited_6ec62a84d77517c9b7daa78af6ac0624_75933cd6.jpg',
    tag: 'Oil & Gas',
    dark: true,
  },
  {
    icon: 'ri-search-eye-line',
    title: 'Technical Equipment Inspection',
    description: 'Detailed technical diagnosis and inspection of industrial equipment, identifying potential failures before they become critical problems.',
    image: 'https://public.readdy.ai/ai/img_res/edited_ac86fdbcc2ff33a1d05e128ae9162b3e_75933cd6.jpg',
    tag: 'Inspection',
  },
  {
    icon: 'ri-blaze-line',
    title: 'Ventilation System Maintenance',
    description: 'Maintenance and optimization of industrial ventilation systems, ensuring air quality, worker safety and process efficiency.',
    image: 'https://public.readdy.ai/ai/img_res/edited_8d762980a70930b9a72097e4a32a0d10_75933cd6.jpg',
    tag: 'Ventilation',
  },
  {
    icon: 'ri-tools-line',
    title: 'Preventive & Corrective Maintenance',
    description: 'Structured preventive and corrective maintenance programs to maximize equipment lifespan and minimize unplanned downtime.',
    image: 'https://public.readdy.ai/ai/img_res/edited_796c426e1b97e15b704a043b3e81a459_75933cd6.jpg',
    tag: 'Maintenance',
  },
];

const headingPT = {
  tag: 'O que fazemos',
  title1: 'Serviços Técnicos',
  titleHighlight: 'Especializados',
  desc: 'Oferecemos uma gama completa de serviços técnicos industriais, com equipas altamente qualificadas e comprometidas com a excelência operacional.',
};

const headingEN = {
  tag: 'What we do',
  title1: 'Specialized',
  titleHighlight: 'Technical Services',
  desc: 'We offer a complete range of industrial technical services, with highly qualified teams committed to operational excellence.',
};

export default function ServicesSection() {
  const { lang } = useLang();
  const services = lang === 'PT' ? servicesPT : servicesEN;
  const h = lang === 'PT' ? headingPT : headingEN;

  return (
    <section id="services" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-16">
          <div>
            <span className="text-[#F97316] text-sm font-semibold uppercase tracking-widest">
              {h.tag}
            </span>
            <h2 className="text-4xl md:text-5xl font-extrabold text-[#0B1A35] mt-2 leading-tight">
              {h.title1}
              <br />
              <span className="text-[#F97316]">{h.titleHighlight}</span>
            </h2>
          </div>
          <p className="text-gray-500 text-base max-w-md leading-relaxed">{h.desc}</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service) => (
            <div
              key={service.title}
              className={`rounded-2xl overflow-hidden group cursor-pointer transition-transform duration-300 hover:-translate-y-1 ${
                service.dark ? 'bg-[#0B1A35]' : 'bg-[#F8F9FA]'
              }`}
            >
              <div className="w-full h-52 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-6">
                <span
                  className={`inline-block text-xs font-bold uppercase tracking-wider px-3 py-1 rounded-full mb-4 ${
                    service.dark ? 'bg-[#F97316]/20 text-[#F97316]' : 'bg-[#F97316]/10 text-[#F97316]'
                  }`}
                >
                  {service.tag}
                </span>
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-8 h-8 flex items-center justify-center">
                    <i className={`${service.icon} text-xl ${service.dark ? 'text-[#F97316]' : 'text-[#0B1A35]'}`}></i>
                  </div>
                  <h3 className={`font-bold text-base leading-snug ${service.dark ? 'text-white' : 'text-[#0B1A35]'}`}>
                    {service.title}
                  </h3>
                </div>
                <p className={`text-sm leading-relaxed ${service.dark ? 'text-white/60' : 'text-gray-500'}`}>
                  {service.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
